import React from 'react'

export default function(props : { color: string } = { color: '#4BB9AA' }) {
    return (
        <svg width='8' height='12' viewBox='0 0 8 14' fill='none' xmlns='http://www.w3.org/2000/svg'>
            <path d='M1 13L7 7L1 1' stroke={ props.color } strokeWidth='2' strokeLinecap='round' strokeLinejoin='round'/>
        </svg>
    )
}
